import { Navigate } from "react-router-dom";
import VerticalLayout from "Layouts/VerticalLayout";
import HorizontalLayout from "Layouts/HorizontalLayout/index";
import "../assets/scss/theme.scss";
import NonAuthLayout from "Layouts/NonLayout";
import { LAYOUT_TYPES } from "Components/constants/layout";
import { createSelector } from "reselect";
import { useSelector } from "hooks/useSelector";
import { TLayoutType } from "types/layout";
import { useDispatch } from "react-redux";
import { changeLayout } from "slices/thunk";
import { useEffect } from "react";
import { RestrictedPage } from "Components/ui/RestrictedPage";
import Pages404 from "pages/Utility/pages-404";

const getLayout = (layoutType: any) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case LAYOUT_TYPES.VERTICAL:
      Layout = VerticalLayout;
      break;
    case LAYOUT_TYPES.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

const PrivateWrapper = ({
  children,
  auth,
  noAuth,
  layoutType = LAYOUT_TYPES.VERTICAL,
  permission,
  feature,
}: {
  children: JSX.Element;
  auth?: Boolean;
  noAuth?: Boolean;
  layoutType?: TLayoutType;
  permission?: string;
  feature?: string;
}) => {
  const dispatch = useDispatch<any>();

  const selectLeadData = createSelector(
    (state: any) => state.Layout,
    (layout) => ({
      layoutTypes: layout.layoutTypes,
    })
  );
  const { layoutTypes } = useSelector(selectLeadData);

  const Layout = getLayout(layoutTypes);

  const { accessToken, permissions, isSuperAdmin } = useSelector(
    (state) => state.Login
  );

  useEffect(() => {
    dispatch(changeLayout(LAYOUT_TYPES[layoutType.toUpperCase()]));
  }, [dispatch, layoutType]);

  if (!auth && !noAuth) {
    return <Pages404 />;
  }

  if (noAuth) {
    return !accessToken ? (
      <NonAuthLayout>{children}</NonAuthLayout>
    ) : (
      <Navigate to="/" replace />
    );
  }
  if (!auth) {
    return <NonAuthLayout>{children}</NonAuthLayout>;
  }

  return accessToken ? (
    isSuperAdmin ||
    feature === "dashboard" ||
    // feature === "settings" ||
    permissions[feature || ""]?.includes(permission) ? (
      <Layout>{children}</Layout>
    ) : (
      <Layout>
        <RestrictedPage />
      </Layout>
    )
  ) : (
    <Navigate to="/login" replace />
  );
};
export default PrivateWrapper;
